module.exports = __webpack_public_path__ + "static/new-gsc-logo-fr-b542a7426e297a6bb2de6aa2e93e732a.png";